module.exports = __webpack_public_path__ + "img/lc.82209f2e.svg";